module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-gallery/ma-gallery-17-d3fbe65f2e3598579657d193bb65290d.jpg";